<template>
  <footer class="footer">
    <div class="container">
      <div>
        Ascenti Physio Limited and Ascenti Health Limited are members of the Ascenti Group and trade under the Ascenti brand.
        Incorporated in England &amp; Wales | Company numbers: 04530716 and 03225768 | Registered office: Carnac House, Cams Hall Estate, Fareham PO16 8UZ | <a href="https://www.ascenti.co.uk" class="link" target="_blank" rel="nofollow noopener">www.ascenti.co.uk</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Bottom",
}
</script>

<style lang="scss">
.footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 150px;
  padding: 1.5rem 1rem;
  background-color: $footer-bg;
  color: $footer-color;
  font-size: $footer-font-size;
  font-weight: $footer-font-weight;

  .link {
    color: $footer-link-color;

    &:not(.disabled) {
      @include focusHover {
        color: $footer-link-color-focus;
      }

      @include active {
        color: $footer-link-color;
        text-decoration: none;
      }
    }
  }
}

@include screen(md) {
  .footer {
    height: 80px;
    padding: 1.5rem 1rem;

    .container > div {
      max-width: 650px;
    }
  }
}
</style>
